<template>
  <div>
    <PageTitleVue> Meus dados </PageTitleVue>
    <!-- <ContainerVue> -->
      <Form id="form-fields" :description-title="'Editar perfil'">
        <PasswordFormVue :create="false" :description-title="'Altere sua senha de acesso'" />
        <div class="w-full flex justify-center mt-4">
          <CreateButton
            @click="editMe"
            :icon="'fa-solid fa-check'"
            :label="'Salvar'"
          />
        </div>
      </Form>
    <!-- </ContainerVue> -->
    <FloatBackPage />
  </div>
</template>

<script setup>
import FloatBackPage from '@/components/Buttons/FloatBackPage.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import ProfileService from '../services/profile.service'
import ContainerVue from '@/components/Container.vue'
import Form from './Form.vue'
import { onMounted } from 'vue'
import { dataUser } from '../store'
import { setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { useRoute } from 'vue-router'
import { storeApp } from '@/store'
import * as yup from './../../../validator'
import { showToast as toast } from '@/helpers/UseToasts'
import PasswordFormVue from './PasswordForm.vue'

const store = dataUser
const appStore = storeApp.state
const meUuid = useRoute()

const schema = yup.object().shape({
  user: yup.object().shape({
    name: yup.string().label('Nome').required().min(3),
    email: yup.string().email().label('Email').required().min(10)
  })
})

const password = yup.object().shape({
  password: yup.object().shape({
    old: yup.string().min(5, 'Inválido').required('Por favor informe a senha anterior'),
    newPass: yup.string().required('É necessário informar a nova senha').min(5, 'Deve ter no mínimo 5 caracteres'),
    confirm: yup.string().oneOf([yup.ref('newPass'), null], 'As senhas devem ser iguais').required('Por favor confirme a nova senha')
  })
})

onMounted(async () => {
  store.commit('reset')
  appStore.loading = true
  await getMeData()
  appStore.loading = false
})

async function getMeData () {
  appStore.loading = true
  await ProfileService.getMeProfile(meUuid.params.id)
    .then((res) => {
      store.state.user.name = res.data.name
      store.state.user.function = res.data.function
      store.state.user.role = res.data.roles_id
      store.state.user.email = res.data.email
      store.state.user.phone = res.data.phone
      // store.state.user.password = res.data.password
      store.state.imgPath = res.data.image_profile

      console.log(store.state.user);
      

      appStore.loading = false
    })
    .catch((err) => {
      appStore.loading = false
      toast(
        'Aviso',
        'Dados do perfil não encontrados',
        'error'
      )
    })
}

async function editMe () {
  appStore.loading = true
  
  const data = Object.assign({}, store.state)

  let validatePassword
  if (store.state.password.newPass !== undefined) { 
    validatePassword = (await validateFormField(password, store.state)) 
    console.log(validatePassword);
  } else {
    delete data.password
  }

  if (validatePassword && validatePassword.length > 0) {
    setFormFieldsError(validatePassword)
    appStore.loading = false
    return
  }

  const errors = []
  await schema.validate(store.state, { abortEarly: false }).catch((err) => {
    err.inner.forEach((e) => {
      errors.push({
        name: e.path,
        msg: e.message
      })
    })
  })

  if (errors.length > 0) {
    appStore.loading = false
    setFormFieldsError(errors)
    return
  }

  if (
    data.user.image_profile &&
    typeof (data.user.image_profile) === 'object' &&
    typeof (data.imgPath) === 'string' &&
    data.imgPath !== '[]'
  ) {
    await ProfileService.editImage(data.user.image_profile, data.imgPath).then(res => {
      data.imgPath = res.data
      data.user.image_profile = res.data
    }).catch(err => {
      toast(
        'Aviso',
        'Upload de novo arquivo não concluído',
        'error'
      )
    })
  } else if (data.user.image_profile && typeof (data.user.image_profile) !== 'string') {
    await ProfileService.saveImage(data.user.image_profile).then(res => {
      data.imgPath = res.data
      data.user.image_profile = res.data
    }).catch(err => {
      toast(
        'Aviso',
        'Upload de arquivo não concluído',
        'error'
      )
    })
  } else { data.user.image_profile = data.imgPath }

  data.user.company_id = localStorage.getItem('__company')

  await ProfileService.updateMe(meUuid.params.id, data)
    .then((res) => {
      if (res.data.success) {
        toast(
          'Sucesso',
          'Seus dados foram atualizados',
          'success'
        )
      }
      appStore.loading = false
    })
    .catch((err) => {
      appStore.loading = false

      if (err.response.status && err.response.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err.response.status && err.response.status === 401) {
        return toast(
          'Aviso',
          'Sessão expirada',
          'error'
        )
      }

      toast(
        'Aviso',
        'Algo deu errado ao atualizar seus dados',
        'error'
      )
      appStore.loading = false
    })
}

</script>
